import { Box, Button, Typography } from '@mui/material';
import React from 'react';

interface EmptyStateProps {
  searchQuery: string;
  onClearSearch: () => void;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ searchQuery, onClearSearch }) => {
  return (
    <Box
      sx={{
        textAlign: 'center',
        p: 5,
        bgcolor: 'background.paper',
        borderRadius: '12px',
        mt: 2,
        boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
      }}
    >
      <Typography variant="h5" gutterBottom fontWeight={600}>
        No courses found
      </Typography>
      <Typography variant="body1" color="text.secondary">
        {searchQuery ? (
          <>No courses match your search criteria. Try adjusting your search.</>
        ) : (
          <>There are no courses available in the library at this time.</>
        )}
      </Typography>
      {searchQuery && (
        <Button
          variant="outlined"
          onClick={onClearSearch}
          sx={{ mt: 3, borderRadius: '10px', textTransform: 'none' }}
        >
          Clear Search
        </Button>
      )}
    </Box>
  );
};